var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#6f29a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 2.667c7.3637 1e-5 13.333 5.9692 13.333 13.333 0 7.3637-5.9693 13.333-13.333 13.333-7.3638 0-13.333-5.9693-13.333-13.333 0-7.3638 5.9692-13.333 13.333-13.333zm0 7c-0.5523 0-1 0.44771-1 1v5.333c0 0.2652 0.1054 0.5196 0.293 0.707l3.333 3.333c0.3905 0.3906 1.0235 0.3906 1.414 0 0.3906-0.3905 0.3906-1.0235 0-1.414l-3.04-3.0401v-4.9189c0-0.5523-0.4477-1-1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon_clock.7c8c19882e56587d0bb9525dcad0c49b.svg";
export { ForwardRef as ReactComponent };